import { GetStaticProps } from 'next'
import { connect } from 'react-redux'
import Academy from '#/containers/Academy'
import { getAllAcademyVideosForHome } from '#/containers/Academy/lib/api'

export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
  const allNews = await getAllAcademyVideosForHome(preview, 6, null)

  return {
    props: { allNews, preview },
    revalidate: 1
  }
}

const mapStateToProps = (state: TopHap.StoreState) => ({ isMobile: state.global.isMobile.any })

export default connect(mapStateToProps, {})(Academy)
